import { render, staticRenderFns } from "./DonutCSS.vue?vue&type=template&id=70f2285c&"
import script from "./DonutCSS.vue?vue&type=script&lang=js&"
export * from "./DonutCSS.vue?vue&type=script&lang=js&"
import style0 from "./DonutCSS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardTitle,VMenu})
